<template>
<!-- MAIN CONTAINER -->
<div id="mainContainer">
<h1>ARTWORKS</h1>
    <!-- GALLERY -->
    <div id="gallery">
                    <span class="imgContainer">
                        <img src="/static/img/artworks/artwork1.jpg">
                          <span class="imgOverlay" title="Cybersawman" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/artworks/artwork2.jpg">
                        <span class="imgOverlay" title="Robotic Mercenary" label="PHOTOSHOP"></span>
                    </span>
                    
                    <span class="imgContainer">
                        <img src="/static/img/artworks/artwork5.jpg">
                          <span class="imgOverlay" title="Gatling Fat Man" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/artworks/artwork4.jpg">
                          <span class="imgOverlay" title="Mutant Flies" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/artworks/artwork3.jpg">
                          <span class="imgOverlay" title="Mutant Plant" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork8.jpg">
                          <span class="imgOverlay" title="Fancy Button" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork7.jpg">
                          <span class="imgOverlay" title="MiArmored" label="FLASH"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/artworks/artwork10.jpg">
                          <span class="imgOverlay" title="DodeZone" label="FLASH"></span>
                    </span>

                    <span class="imgContainer">
                        <img src="/static/img/artworks/artwork9.jpg">
                          <span class="imgOverlay" title="DodeZone" label="FLASH"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork11.gif">
                          <span class="imgOverlay" title="MiArmored" label="FLASH"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork6.jpg">
                          <span class="imgOverlay" title="LightBall" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork12.png">
                          <span class="imgOverlay" title="Boxer" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork13.jpg">
                          <span class="imgOverlay" title="Cyclop" label="PHOTOSHOP"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork14.jpg">
                          <span class="imgOverlay" title="Troll House" label="FLASH"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork15.jpg">
                          <span class="imgOverlay" title="Carzy Frog" label="FLASH"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork16.jpg">
                          <span class="imgOverlay" title="Characters" label="FLASH"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork18.jpg">
                          <span class="imgOverlay" title="The Corporation" label="ILLUSTRATOR"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork17.jpg">
                          <span class="imgOverlay" title="Amazon" label="DRAWING"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork19.jpg">
                          <span class="imgOverlay" title="Swordman" label="DRAWING"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork20.jpg">
                          <span class="imgOverlay" title="3D Character" label="DRAWING"></span>
                    </span>

                    <span class="imgContainer noScale">
                        <img src="/static/img/artworks/artwork21.jpg">
                          <span class="imgOverlay" title="Boxer" label="PHOTOSHOP"></span>
                    </span>
              </div>
              <!-- END OF GALLERY -->
</div>
<!-- END OF MAIN CONTAINER -->
</template>

<script>

export default {
   mounted(){
    this.initGallery();

   },
   beforeDestroy() {
    this.removeGallery();
   }
}

</script>



// WEBPACK FOOTER //
// Artworks.vue?1522a791